import { useDispatch, useSelector } from 'react-redux'
import { updateUserFormObject, updateUsers, initFormObjects } from '@store/slice/usersSlice'
import { updateNotification } from '@store/slice/mainSlice'
import { post } from '@util/xhrAPI'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { ROLE_SUPER_ADMIN } from '@router/Routes'
import Div from '@ui/layout/Div'
import Buttons from '@ui/elements/Buttons'
import { userFormFields, userSaveUrl, userFormObject as formObject } from '@form/userFormFields'
import useToggle from '@hook/useToggle'
import useStoreUpdate from '@hook/useStoreUpdate'
import useFormData from '@hook/useFormData'
import useDynamicForm from '@hook/useDynamicForm'
import useMainData from '@hook/useMainData'
import { useEffect } from 'react'

const CreateUser = () => {
  const { users, userFormObject, errors } = useSelector(state => state.users)
  const { data, mission } = useSelector(state => state.main)
  const dispatch = useDispatch()
  const loadData = useMainData()
  const [t] = useTranslation('user')
  const renderFormData = useFormData()
  const [isLoading, toggleLoading] = useToggle(false)
  const toggleDynamicForm = useDynamicForm()
  const [updateFormObject, updateFormObjectProp] = useStoreUpdate(dispatch, updateUserFormObject, userFormObject)
  const navigate = useNavigate()

  const saveForm = () => {
    post(userSaveUrl, renderFormData(userFormObject), response => {
      toggleLoading()
      const { code, errors, user } = response
      if (code === 200 && !errors.length) {
        window.scroll({ top: 0 })
        dispatch(updateUsers({ ...users, [user.id]: { ...user } }))
        dispatch(initFormObjects())
        dispatch(updateNotification({ type: 'is-success', message: t('alerts.user_saved') }))
      }
      toggleLoading()
    })
  }

  const fetchInitialData = () => {
    const dataObject = {
      cities: 'cities',
      roles: 'roles'
    }
    loadData(dataObject)
  }

  useEffect(() => {
    dispatch(updateUserFormObject({ ...formObject, mission: mission.id }))
    fetchInitialData()
  }, [])

  return (
    <Div cssClass='create-user'>
      <Buttons buttons={
        {
          cssClass: 'back-to-list is-info',
          callback: () => navigate(ROLE_SUPER_ADMIN['users']),
          text: t('actions.back_to_users_list'),
          icon: 'icon-keyboard_arrow_left'
        }
      } />
      <Div cssClass='form-header'>
        <h2 className='scene-title'>{t('titles.user_creation')}</h2>
      </Div>
      <Div cssClass='form columns is-multiline'>
        {userFormFields(userFormObject, updateFormObject, updateFormObjectProp, saveForm, errors, isLoading, t, data, toggleDynamicForm)}
      </Div>
    </Div>
  )
}

export default CreateUser